import controller from './chart-co2.controller';
import { template, bindings } from '../chart-abstract-base';

export default {
    bindings,
    template,
    controller
};
